<template>
  <div>
    <h5 class="text-sm font-medium tracking-wide text-gray-700 mb-2">Assets</h5>

    <Loader v-if="loading" />

    <div v-else class="mt-2 grid grid-cols-2 gap-2">
      <AssetCard
        v-for="(asset, idx) in assets"
        :key="asset.id || idx"
        :asset="asset"
        :project-asset="getProjectAsset(asset)"
      />
      <div v-if="assets.length === 0" class="px-4 py-3 text-sm">There are no Assets.</div>
    </div>
  </div>
</template>

<script>
import AssetCard from './relatedAssets/AssetCard.vue';

export default {
  name: 'RelatedAssets',

  components: {
    AssetCard,
  },

  props: {
    editable: Boolean,
    taskId: {
      type: String,
      required: true,
    },
    projectId: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      loading: false,
    };
  },

  computed: {
    assets() {
      return this.$store.getters['ui/taskAssets/assetsByTask'](this.taskId);
    },
    assetIds() {
      return this.assets.map((asset) => asset.id);
    },
    projectAssets() {
      return this.$store.getters['ui/projectProjectAssets/projectAssetsByProject'](this.projectId);
    },
  },
  created() {
    this.load();
  },
  destroyed() {
    this.$store.dispatch('ui/taskAssets/clear', { taskId: this.taskId });
  },
  provide() {
    return {
      getProjectAssets: this.loadProjectAssets,
      reload: this.load,
    };
  },
  methods: {
    getProjectAsset(asset) {
      return this.projectAssets.find((projectAsset) => projectAsset.assetId === asset.id);
    },
    async load() {
      this.loading = true;

      try {
        await this.$store.dispatch({
          type: 'ui/taskAssets/load',
          taskId: this.taskId,
          params: {
            include: 'assetable',
          },
        });

        await this.loadProjectAssets();
      } catch (error) {
        //
      } finally {
        this.loading = false;
      }
    },
    async loadProjectAssets() {
      if (typeof this.projectId !== 'string' || this.assetIds.length === 0) {
        return;
      }

      try {
        await this.$store.dispatch({
          type: 'ui/projectProjectAssets/load',
          projectId: this.projectId,
          params: {
            filter: {
              asset_id: this.assetIds.join(','),
            },
            include: [
              'approvalRequestsCount',
              'approvalClaimsCount',
              'approvedApprovalRequestsCount',
              'rejectedApprovalRequestsCount',
              'mailedApprovalRequestsCount',
              'pendingApprovalRequestsCount',
              'pendingApprovalRequest',
            ].join(','),
          },
        });
      } catch (error) {
        //
      }
    },
  },
};
</script>
